import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  loginUser : {            // Login User Info
    siteCd : null,
    userNm : null,
    userId : null,
    userEmail : null,
    curCmpnId: null,
    curCmpnNm : null,
    creaIpAddr :null,
  },
  isLogin : false,
  isConcurrentLogin: false,
  isSmtLogin: false,
  isTokenExpiration: false,
  accessAuthority: {
    accessDenied : false,
    otpDenied:false,
    allowedIpNull:false,
    allowedIpDenied:false,
    loginDeniedConCurrent: false,
  },
  browserHistory: {
    compliance: {
      isRecall: false,
      isOnInspection: false,
      complianceFilters: {}
    },
    policy: {
      isRecall: false,
      policyFilters: {}
    },
    audit: {
      isRecall: false,
      auditFilters: {}
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js